import { render, staticRenderFns } from "./PutIn.vue?vue&type=template&id=f2a16d6e&scoped=true&"
import script from "./PutIn.vue?vue&type=script&lang=js&"
export * from "./PutIn.vue?vue&type=script&lang=js&"
import style0 from "./PutIn.vue?vue&type=style&index=0&id=f2a16d6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a16d6e",
  null
  
)

export default component.exports